import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from 'react-router-dom'
import logo from "../../assets/boxxdocks-logo-grey.svg"
import EnterDetails from "../Form/EnterDetails";
import AddComment from "../AddComment/AddComment";
import AddPhoto from "../AddPhoto/AddPhoto";
import Confirmation from "../Confirmation/Confirmation";
import { setStateRefresh } from "../../redux/globalSlice";

const Reporting = () => {
  const [searchParams] = useSearchParams();
  const locationName = searchParams.get("locationName");
  const [reportingType, setReportingType] = useState("An Incident");
  const [getDataFromLocalStorage, setGETDataFromLocalStorage] = useState("Reporting");
  const dispatch = useDispatch();
  const stateRefresh = useSelector((state) => state.global.stateRefresh);
  const submitHandlerReport = () => {
    localStorage.setItem("serviceReportingType", reportingType);
    dispatch(setStateRefresh(!stateRefresh));
    localStorage.setItem("getServicePage", "EnterDetails");
  }
  // useEffect(() => {
  //   localStorage.removeItem("getServicePage");
  //   setGETDataFromLocalStorage("Reporting")
  // }, []);
  useEffect(() => {
    setGETDataFromLocalStorage(localStorage.getItem("getServicePage") || "Reporting");
  }, [stateRefresh])
  return (
    <>
      {getDataFromLocalStorage === "Reporting" && (
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-content">
                <div className="logo mx-auto">
                  <img src={logo} className="img-fluid mx-auto" alt="" />
                </div>
                <p className="mb-0 heading">What are you reporting at {locationName} </p>

                <div className="code-box">
                  <form action="">


                    <div className="radiobtn">
                      <input
                        type="radio"
                        id="huey"
                        name="drone"
                        value="An Incident"
                        checked={reportingType === "An Incident"}
                        onChange={(e) => setReportingType(e.target.value)}
                      />
                      <label htmlFor="huey">An Incident</label>
                    </div>

                    <div className="radiobtn">
                      <input
                        type="radio"
                        id="dewey"
                        name="drone"
                        value="Maintenance"
                        checked={reportingType === "Maintenance"}
                        onChange={(e) => setReportingType(e.target.value)}
                      />
                      <label htmlFor="dewey">Maintenance</label>
                    </div>

                    <div className="radiobtn">
                      <input
                        type="radio"
                        id="louie"
                        name="drone"
                        value="Safety Concern"
                        checked={reportingType === "Safety Concern"}
                        onChange={(e) => setReportingType(e.target.value)}
                      />
                      <label htmlFor="louie">Safety Concern</label>
                    </div>

                    <div className="radiobtn">
                      <input
                        type="radio"
                        id="Feedback"
                        name="drone"
                        value="Feedback"
                        checked={reportingType === "Feedback"}
                        onChange={(e) => setReportingType(e.target.value)}
                      />
                      <label htmlFor="Feedback">Feedback</label>
                    </div>



                    <div className="button-box">
                      <button type="button" className="btn-continue" onClick={submitHandlerReport}>continue</button>

                    </div>
                  </form>
                </div>

              </div>
            </div>
          </div>
        </div>
      )}

      {
        getDataFromLocalStorage === "EnterDetails" && (
          <EnterDetails />
        )
      }
      {
        getDataFromLocalStorage === "AddComment" && (
          <AddComment />
        )
      }
      {
        getDataFromLocalStorage === "AddPhoto" && (
          <AddPhoto />
        )
      }
      {
        getDataFromLocalStorage === "Confirmation" && (
          <Confirmation />
        )
      }

    </>


  )
}

export default Reporting